// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import React, { ReactElement } from 'react';
import _ from 'lodash';

import './THListChoice.scss';

interface THListChoiceProps<T> {
    value?: T;
    onChange?: (value: T) => void;
    dataSource?: T[];
    children: (item: T, selected: boolean) => ReactElement;
    disabled?: boolean;
}

export const THListChoice = <T,>({
    dataSource,
    value,
    onChange,
    children,
    disabled,
}: THListChoiceProps<T & { disabled?: boolean }>): ReactElement => (
    <div className="th-list-choice">
        {dataSource?.map((item, index) => {
            const selected = _.isEqual(item, value);
            const itemDisabled = typeof item.disabled === 'boolean' ? item.disabled : false;
            return React.cloneElement(children(item, selected), {
                key: `list-choice ${index}`,
                onClick: () => !disabled && !itemDisabled && onChange?.(item),
                className: classList('th-list-choice__item', { selected: selected, disabled: itemDisabled }),
            });
        })}
    </div>
);
